import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ThunkGetSmsChannelHistory, ThunkGetSmsTextTemplateVariables } from 'store/smsConversations/thunks';
import { ISmsChannelHistory } from 'services/smsConversations/types';
import { RootState } from 'store/index';
import { ThunkGetTeamsChatMessages } from 'store/teamsChat/thunks';
import { LabelValue } from '../../services/common/types';

interface IInitialState {
  history: ISmsChannelHistory[];
  variables: LabelValue[];
  orderDesc: boolean;
}

const initialState: IInitialState = {
  history: [],
  variables: [],
  orderDesc: false,
};

const smsConversations = createSlice({
  name: 'smsConversations',
  reducers: {
    addHistory: (state, action) => {
      if (!state.orderDesc) {
        state.history.push(action.payload);
      } else {
        state.history = [action.payload, ...state.history];
      }
    },
    changeHistoryItemState: (
      state,
      action: PayloadAction<{ id: number; state: boolean; message?: string }>,
    ) => {
      state.history = state.history.map(i =>
        i.id === action.payload.id
          ? {
              ...i,
              loading: action.payload.state,
              body: action.payload?.message ? action.payload.message : i.body,
            }
          : i,
      );
    },
  },
  initialState,
  extraReducers: builder => {
    builder.addCase(ThunkGetSmsChannelHistory.fulfilled, (state, action) => {
      state.history = action.payload;
    });
    builder.addCase(ThunkGetSmsTextTemplateVariables.fulfilled, (state, action) => {
      state.variables = action.payload;
    });
    builder.addCase(ThunkGetTeamsChatMessages.fulfilled, (state, action) => {
      state.history = action.payload;
    });
  },
});

export default smsConversations.reducer;
export const { addHistory, changeHistoryItemState } = smsConversations.actions;
export const SMSChannelHistorySelector = (state: RootState): ISmsChannelHistory[] =>
  state.smsConversations.history;
export const SMSTextTemplateVariablesSelector = (state: RootState): LabelValue[] =>
    state.smsConversations.variables;
